module.exports = __webpack_public_path__ + "assets/static/media/splash_screen_1.3848a07c.png";